import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { Layout } from 'antd'

import { ReportsDrawer } from '../../components/ReportsDrawer'
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from '../../constants/ThemeSetting'
import App from '../../routes/adminRoutes'
import Sidebar from '../Sidebar'
import Topbar from '../Topbar'
import AboveHeader from '../Topbar/AboveHeader'
import BelowHeader from '../Topbar/BelowHeader'
import HorizontalDark from '../Topbar/HorizontalDark'
import HorizontalDefault from '../Topbar/HorizontalDefault'
import InsideHeader from '../Topbar/InsideHeader'
import NoHeaderNotification from '../Topbar/NoHeaderNotification'

const { Content } = Layout

export class MainApp extends Component {
  getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-container-wrap'
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-container-wrap'
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-container-wrap'
      default:
        return ''
    }
  }

  getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />
      case NAV_STYLE_FIXED:
        return <Topbar />
      case NAV_STYLE_DRAWER:
        return <Topbar />
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />
      default:
        return null
    }
  }

  getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) {
      return <Sidebar />
    }

    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />
      case NAV_STYLE_DRAWER:
        return <Sidebar />
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />
      default:
        return null
    }
  }

  render() {
    const { match, width, navStyle, location } = this.props
    const isActionsCreatePage = location.pathname === '/actions/create'
    const contentStyle = isActionsCreatePage ? { overflow: 'clip' } : {}

    return (
      <Layout className="gx-app-layout">
        {this.getSidebar(navStyle, width)}
        <Layout>
          {this.getNavStyles(navStyle)}
          <Content className={`gx-layout-content ${this.getContainerClass(navStyle)}`} style={contentStyle}>
            <App match={match} />
            <ReportsDrawer />
          </Content>
        </Layout>
      </Layout>
    )
  }
}

const mapStateToProps = ({ settings }) => {
  const { width, navStyle } = settings
  return { width, navStyle }
}

export default withRouter(connect(mapStateToProps)(MainApp))
